import { Accordion, AccordionHeader, AccordionStatus, AccordionTable } from '@dmc/ui';
import { useTranslation } from 'react-i18next';
import { GridControlled } from '@casops/components/tables/grid/GridControlled';
import { lockColumn } from '@casops/components/tables/grid/columnDefs';
import styles from './SafetyNotifications.module.scss';
import { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';

const footnoteSymbol = '*';

interface SafetyNotificationTable {
  id: number;
  userRole: string;
  appNotification: string;
  emailNotification: string;
}

export const SafetyNotifications = () => {
  const { t } = useTranslation();

  const columnDefs = useMemo<ColDef<SafetyNotificationTable>[]>(
    () => [
      { field: 'userRole', headerName: t('Fields.Roles') },
      { field: 'appNotification', headerName: t('Field.InAppNotification.Label') },
      { field: 'emailNotification', headerName: t('Fields.Email') },
    ],
    [t],
  );

  const rowData = useMemo<SafetyNotificationTable[]>(() => {
    return [
      {
        id: 1,
        userRole: t('Model.Plural.SafetyManager_other'),
        appNotification: t('Yes') + footnoteSymbol,
        emailNotification: t('Yes'),
      },
      {
        id: 2,
        userRole: t('OtherUsers'),
        appNotification: t('Yes'),
        emailNotification: t('No'),
      },
      {
        id: 3,
        userRole: t('Field.ExternalTeamMembers.Label'),
        appNotification: EmptyCell,
        emailNotification: t('Yes'),
      },
    ];
  }, [t]);

  return (
    <Accordion
      defaultExpanded={false}
      status={AccordionStatus.Informative}
      icon="information"
      header={
        <AccordionHeader
          title={t('Field.SafetyNotifications.Label')}
          subtitle={t('Field.SafetyNotifications.Description')}
        />
      }
    >
      <AccordionTable hasRows={true} noRowsMessage="">
        <GridControlled<SafetyNotificationTable>
          sliceKey="safety-notifications"
          autoheight={true}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={lockColumn}
        />
        <div className={styles.helperText}>
          {footnoteSymbol + t('Field.SafetyNotifications.HelperText')}
        </div>
      </AccordionTable>
    </Accordion>
  );
};
